import { useMutation, useQuery } from 'react-query'
import { axiosQuery as axiosClient } from 'net/ajax'

const getCustomerGroups = () => {
    return axiosClient
        .get('/ratesmgr/criteria/customer_groups')
        .then(({ data }) => data)
        .catch(error => {
            // Handle 401 redirect responses gracefully - return empty array during redirect
            if (error?.response?.status === 401 && error?.response?.data?.redirect) {
                return [] // Return empty array so component doesn't crash during redirect
            }
            throw error // Re-throw other errors
        })
}

export const useGetCustomerGroups = () => {
    const { data: customerGroups = [], ...rest } = useQuery(
        ['customer_groups'],
        getCustomerGroups
    )

    return { customerGroups, ...rest }
}

export const createCustomerGroup = (variables) =>
    axiosClient.post('/ratesmgr/criteria/customer_groups', {
        render_entity: true,
        ratesmgr_criteria_customer_group: variables,
    })

export const useCreateCustomerGroup = () => {
    const props = useMutation(createCustomerGroup)

    return {
        isSuccess: props['isSuccess'],
        isLoading: props['isLoading'],
        errors: props.error,
        isError: props['isError'],
        createCustomerGroup: props.mutate,
    }
}
